import {IServiceFactoryExtended} from '../../../service-factory-extended.interface';
import {DeepLinkActionDescriptor} from '../deep-link-parsers/parsers/deep-link-parser.interface';
import {ICasinoLegacyDeepLinkActionChain} from './casino-legacy-deep-link-action-chain';
import {IDeepLinkBuilder} from '../deep-link-builders/deep-link-builder.interface';
import {DeepLinkExecutionContext} from './deep-link-execution-context.interface';


export abstract class CasinoLegacyDeepLinkActionBase implements ICasinoLegacyDeepLinkActionChain {

  public constructor(protected context: DeepLinkExecutionContext) {

  }

  shouldSkipAction = false;
  skipAction(): void {
    this.shouldSkipAction = true;
  }

  get services(): IServiceFactoryExtended {
    return this.context.services;
  }

  get descriptor(): DeepLinkActionDescriptor{
    return this.context.descriptor;
  }

  get nextAction(): ICasinoLegacyDeepLinkActionChain | null {
    return this.context.nextAction;
  }

  get deepLinkBuilder(): IDeepLinkBuilder{
    return this.context.deepLinkBuilder;
  }


  abstract execute(): Promise<void>;

  protected _executeNextAction(): Promise<void> {
    let nextAction = this.context.nextAction;
    while (nextAction) {
      if(nextAction.shouldSkipAction) {
        nextAction = nextAction.nextAction;
      } else {
        return this.context.nextAction.execute();
      }
    }

    return Promise.resolve();
  }

  deepLinkToString(): string {
    let result = `"action":"${this.descriptor.action}"`;
    Object.keys(this.descriptor.actionParams).forEach(param => {
        result += `,"${param}":"${this.descriptor.actionParams[param]}"`;
    });
    return "{" + result + "}";
  }
}
